/**
 * `querySelector` that also looks inside open shadow roots: EmbedPDF renders its toolbar in
 * one, and the reader tutorial points at those buttons.
 */
export function queryDeep(selector: string, root: Document | ShadowRoot = document): Element | null {
  const found = root.querySelector(selector);
  if (found) return found;
  for (const el of root.querySelectorAll('*')) {
    if (el.shadowRoot) {
      const inner = queryDeep(selector, el.shadowRoot);
      if (inner) return inner;
    }
  }
  return null;
}
